export default __webpack_public_path__ + "static/media/Cancel.5cd583df.svg";